// TODO: Replace DEFAULT_COVER with real publisher cover photos once assets are available.
import { getPublisherColorsForId } from './publisherColors';

const COVER_MAP = {
    'featured-epl': '/assets/cover/epl.webp',
};

const DEFAULT_COVER = '/assets/cover/ecal-default-cover.jpg';

// Every Nth item falls back to the coverColors gradient instead of DEFAULT_COVER
const GRADIENT_FALLBACK_INTERVAL = 3;

// One pass: decide the cover image, and only assign a coverColor when there
// isn't one (image and gradient are mutually exclusive on the WhatsHot card).
// logoColors is assigned here too — needed regardless of the cover choice —
// instead of a separate assignPublisherColors pass over the same list.
export function assignCoverPhotos(publishers) {
    return publishers.map((p, index) => {
        const logoColors = p.logoColors?.length ? p.logoColors : getPublisherColorsForId(p.pubId);

        if (COVER_MAP[p.id]) {
            return { ...p, coverPhoto: COVER_MAP[p.id], logoColors };
        }
        if (index % GRADIENT_FALLBACK_INTERVAL === 0) {
            const coverColors = p.coverColors?.length ? p.coverColors : getPublisherColorsForId(p.pubId);
            return { ...p, coverPhoto: null, coverColors, logoColors };
        }
        return { ...p, coverPhoto: DEFAULT_COVER, logoColors };
    });
}
